const getters = {
    token: state => state.admin.token,
    info: state => state.admin.info,
    io: state => state.admin.socketio,
};
export default getters
